export const KIOSKO_BUTTON_CLASSES =
  'kiosko:w-[698px] kiosko:!rounded-[56px] kiosko:h-[114px] kiosko:text-kiosko-m';
